import { RelativeTimezoneDateTypeEnum } from '../../../api/mentions/enum/relative-timezone-date-type.enum';
import { DateInputTypesEnum } from '../enums/date-input-types.enum';
import { DateQueryModel } from './date-query.model';
import { DropdownOptionModel } from './dropdown-option.model';

export const dateQueryInputNoneOption: DropdownOptionModel = new DropdownOptionModel(
    'Common.dateQueryInput.none',
    {
        query: null,
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInput24HoursOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.LAST_24_HOURS}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.LAST_24_HOURS),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInput3DaysOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.LAST_3_DAYS}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.LAST_3_DAYS),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInput7DaysOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.LAST_7_DAYS}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.LAST_7_DAYS),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInput30DaysOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.LAST_30_DAYS}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.LAST_30_DAYS),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInput90DaysRelativeTimezoneOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.LAST_90_DAYS}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.LAST_90_DAYS),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInput60DaysOption = new DropdownOptionModel(
    'Common.dateQueryInput.last60Days',
    {
        query: DateQueryModel.getLastXDaysQuery(60),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInput90DaysOption = new DropdownOptionModel(
    'Common.dateQueryInput.last90Days',
    {
        query: DateQueryModel.getLastXDaysQuery(90),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInput120DaysOption = new DropdownOptionModel(
    'Common.dateQueryInput.last120Days',
    {
        query: DateQueryModel.getLastXDaysQuery(120),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInput365DaysOption = new DropdownOptionModel(
    'Common.dateQueryInput.last365Days',
    {
        query: DateQueryModel.getLastXDaysQuery(365),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInput1MonthOption = new DropdownOptionModel(
    'Common.dateQueryInput.last1Month',
    {
        query: DateQueryModel.getLastXMonthsQuery(1),
        type: DateInputTypesEnum.useValue
    }
);
export const dateQueryInput2MonthsOption = new DropdownOptionModel(
    'Common.dateQueryInput.last2Months',
    {
        query: DateQueryModel.getLastXMonthsQuery(2),
        type: DateInputTypesEnum.useValue
    }
);
export const dateQueryInput3MonthsOption = new DropdownOptionModel(
    'Common.dateQueryInput.last3Months',
    {
        query: DateQueryModel.getLastXMonthsQuery(3),
        type: DateInputTypesEnum.useValue
    }
);
export const dateQueryInput4MonthsOption = new DropdownOptionModel(
    'Common.dateQueryInput.last4Months',
    {
        query: DateQueryModel.getLastXMonthsQuery(4),
        type: DateInputTypesEnum.useValue
    }
);
export const dateQueryInput5MonthsOption = new DropdownOptionModel(
    'Common.dateQueryInput.last5Months',
    {
        query: DateQueryModel.getLastXMonthsQuery(5),
        type: DateInputTypesEnum.useValue
    }
);
export const dateQueryInput6MonthsOption = new DropdownOptionModel(
    'Common.dateQueryInput.last6Months',
    {
        query: DateQueryModel.getLastXMonthsQuery(6),
        type: DateInputTypesEnum.useValue
    }
);
export const dateQueryInput7MonthsOption = new DropdownOptionModel(
    'Common.dateQueryInput.last7Months',
    {
        query: DateQueryModel.getLastXMonthsQuery(7),
        type: DateInputTypesEnum.useValue
    }
);
export const dateQueryInput8MonthsOption = new DropdownOptionModel(
    'Common.dateQueryInput.last8Months',
    {
        query: DateQueryModel.getLastXMonthsQuery(8),
        type: DateInputTypesEnum.useValue
    }
);
export const dateQueryInput9MonthsOption = new DropdownOptionModel(
    'Common.dateQueryInput.last9Months',
    {
        query: DateQueryModel.getLastXMonthsQuery(9),
        type: DateInputTypesEnum.useValue
    }
);
export const dateQueryInput10MonthsOption = new DropdownOptionModel(
    'Common.dateQueryInput.last10Months',
    {
        query: DateQueryModel.getLastXMonthsQuery(10),
        type: DateInputTypesEnum.useValue
    }
);
export const dateQueryInput11MonthsOption = new DropdownOptionModel(
    'Common.dateQueryInput.last11Months',
    {
        query: DateQueryModel.getLastXMonthsQuery(11),
        type: DateInputTypesEnum.useValue
    }
);
export const dateQueryInput12MonthsOption = new DropdownOptionModel(
    'Common.dateQueryInput.last12Months',
    {
        query: DateQueryModel.getLastXMonthsQuery(12),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInputTodayOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.TODAY}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.TODAY),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInputYesterdayOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.YESTERDAY}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.YESTERDAY),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInputThisWeekOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.THIS_WEEK}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.THIS_WEEK),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInputLastWeekOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.LAST_WEEK}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.LAST_WEEK),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInputThisMonthOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.THIS_MONTH}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.THIS_MONTH),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInputLastMonthOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.LAST_MONTH}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.LAST_MONTH),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInputLastThreeMonthOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.LAST_THREE_MONTHS}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.LAST_THREE_MONTHS),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInputLastFourMonthsOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.LAST_FOUR_MONTHS}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.LAST_FOUR_MONTHS),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInputLastQuarterOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.LAST_QUARTER}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.LAST_QUARTER),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInputLastFourQuartersOption = new DropdownOptionModel(
    `Common.dateQueryInput.${RelativeTimezoneDateTypeEnum.LAST_FOUR_QUARTERS}`,
    {
        query: DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.LAST_FOUR_QUARTERS),
        type: DateInputTypesEnum.useValue
    }
);

export const dateQueryInputAllOption = new DropdownOptionModel(
    'Common.dateQueryInput.all',
    {
        query: DateQueryModel.getAllQuery(),
        type: DateInputTypesEnum.useValue
    },
);

export const getDateQueryInputCustomOption = () => {
    return new DropdownOptionModel(
        'Common.dateQueryInput.custom',
        {
            query: DateQueryModel.getAbsoluteQuery(),
            type: DateInputTypesEnum.custom
        }
    );
};

export const getDefaultDateInputOptionValuesModel = () => {
    return [
        dateQueryInputAllOption,
        dateQueryInput24HoursOption,
        dateQueryInput3DaysOption,
        dateQueryInput7DaysOption,
        dateQueryInput30DaysOption,
        getDateQueryInputCustomOption()
    ];
};
